var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not_found"},[_c('h1',[_vm._v("404")]),_c('h2',[_vm._v("page not fund")]),_c('router-link',{attrs:{"to":{name: 'Index'}}},[_vm._v(" GO TO HOME ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }